{
  "version": 1,
  "asset_id": "8154bdf1-5368-49d1-a5c0-8d28f90e9d45",
  "project_id": "f4a4cb9e-10ac-4832-a8e3-d05c1765811e",
  "url": "/__l5e/assets-v1/8154bdf1-5368-49d1-a5c0-8d28f90e9d45/jaik-home-hero.mp4",
  "r2_key": "a/v1/f4a4cb9e-10ac-4832-a8e3-d05c1765811e/8154bdf1-5368-49d1-a5c0-8d28f90e9d45/jaik-home-hero.mp4",
  "original_filename": "jaik-home-hero.mp4",
  "size": 8351976,
  "content_type": "video/mp4",
  "created_at": "2026-09-10T04:03:18Z"
}
